/** Digest profile and domain-separated strings — PRD §7.4. */

export const DIGEST_PROFILE = 'signbento-evidence-v1' as const
export type DigestProfile = typeof DIGEST_PROFILE

/** Domain-separated digest domains: SHA256(UTF8(domain) || 0x00 || JCS(value)). */
export const DigestDomain = {
  FIELD_MANIFEST: 'signbento:field-manifest:v1',
  RESPONSE_SET: 'signbento:response-set:v1',
  AUDIT_EVENT: 'signbento:audit-event:v1',
  COMPLETION: 'signbento:completion:v1',
  /** Local self-sign completion digest (S1.4) — never a service attestation. */
  LOCAL_COMPLETION: 'signbento:local-completion:v1',
} as const satisfies Record<string, string>

export type DigestDomainName = (typeof DigestDomain)[keyof typeof DigestDomain]

/** Current schema version for local entities and manifests. */
export const SCHEMA_VERSION = 1 as const

/** Hex encoding rules for SHA-256 digests — PRD §7.4. */
export const SHA256_HEX_PATTERN = /^[0-9a-f]{64}$/

/** Hash string with explicit algorithm prefix as used in fixtures (`sha256:…`). */
export const HASH_STRING_PATTERN = /^sha256:[0-9a-f]{64}$/

/** Exact lossless transport boundary between local `sha256:<hex>` and API digest hex. */
export function sha256HexFromHashString(value: string): string {
  if (!HASH_STRING_PATTERN.test(value)) throw new TypeError('invalid SHA-256 hash string')
  return value.slice('sha256:'.length)
}

export function sha256HashStringFromHex(value: string): string {
  if (!SHA256_HEX_PATTERN.test(value)) throw new TypeError('invalid SHA-256 hex digest')
  return `sha256:${value}`
}

/** First prev_event_digest value in an audit chain — PRD §7.4. */
export const ZERO_EVENT_DIGEST = '0'.repeat(64)

/** Composer profile id recorded on composed artifacts — PRD §7.4. */
export const COMPOSER_PROFILE = 'signbento-composer-v1' as const
